import request from '@/utils/request'

/**
 * 白名单接口 - 判断是否为老用户
 * @returns {Promise<boolean>} true-老用户，false-新用户
 */
export const checkWhitelist = async (): Promise<boolean> => {
  try {
    const response = await request({
      url: '/user/getWhite',
      method: 'get'
    })
    return response.data === true
  } catch(error) {
    return false
  }
}


export default {
  checkWhitelist
}